export default __webpack_public_path__ + "static/google_Desktop8-b6126f4e0ef62d8bee61dd7857e79a1b.svg";